import { Controller } from 'stimulus';
import Chart from 'chart.js';

import isTurbolinksPreview from '../utils/isTurbolinksPreview';

export default class extends Controller {
  connect() {
    if (isTurbolinksPreview()) {
      return;
    }

    const data = JSON.parse(this.data.get('data') || '{}');
    this.chart = new Chart(this.element, data);
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
